import config from 'baseConfig/pg/v2/payments';
import { ALL, BATCH_CAPTURE } from 'baseConfig/pg/constants';

export default {
  [ALL]: {
    TABLE_COLUMNS: [...config.All.TABLE_COLUMNS],
    FILTER_ITEMS: { ...config.All.FILTER_ITEMS },
    SEARCH_ITEMS: [...config.All.SEARCH_ITEMS],
  },
  [BATCH_CAPTURE]: {
    TABLE_COLUMNS: [...config[BATCH_CAPTURE].TABLE_COLUMNS],
    SEARCH_ITEMS: [...config[BATCH_CAPTURE].SEARCH_ITEMS],
  },
};
